export enum TextContentTypes {
  PersonNote = 'PERSON_NOTE',
  CompanyNote = 'COMPANY_NOTE',
  CompanyThesis = 'COMPANY_THESIS',
  IndicationNote = 'INDICATION_NOTE',
  InsightNote = 'INSIGHT_NOTE',
  CRMNote = 'CRM_NOTE',
}
